// extracted by mini-css-extract-plugin
export default {"section":"Section2_section__ABHzX","heading":"Section2_heading__g3abg","grid":"Section2_grid__LpQ1-","card":"Section2_card__+Ur9c"};